import { render } from "./ban-ip-address.vue?vue&type=template&id=517ab190"
import script from "./ban-ip-address.vue?vue&type=script&lang=js"
export * from "./ban-ip-address.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__